import { LocalDateTime } from "@js-joda/core";
import React from "react";
import { STRINGS } from "../strings";
import { decimalHourToDisplay } from "../time";
import { globalize, translate } from "../translate";
import { CALENDAR_SVG } from "../utils/svgs";
import { CALENDAR_ICON, CLOCK_ICON } from "../utils/svgs_new";
import { AppButton } from "./Generic/AppButton";
import { AppIcon } from "./Generic/AppIcon";
import { AppList, AppListItem } from "./Generic/AppList";
import { InfoCard } from "./Generic/InfoCard";

interface Props {
  dateTime: LocalDateTime | null;
  durationMinutes: number | null;
  onClickOpenChangeDateTime: () => void;
  onClickUnscheduleTask: () => void;
  onclickDisabled: () => void;
  isVisitCheckedIn: boolean;
  visitHasCico: boolean;
}

const PatientTaskScheduleDateTime = (props: Props) => {
  if (props.dateTime === null || props.durationMinutes === null) {
    return (
      <div className="PatientTaskScheduleDateTime">
        <AppButton
          onClick={props.onClickOpenChangeDateTime}
          color="primary"
          className="__task-schedule-button"
        >
          <AppIcon icon={CALENDAR_SVG} size={16} />
          <span>{translate(STRINGS.SELECT_DATE_AND_TIME)}</span>
        </AppButton>
      </div>
    );
  }

  const startTime = globalize().formatLocalDateTime(props.dateTime, { time: "short" });
  const endTime = globalize().formatLocalDateTime(
    props.dateTime.plusMinutes(props.durationMinutes),
    { time: "short" }
  );
  const durationText = decimalHourToDisplay(props.durationMinutes / 60, "narrow");

  const isDisabled = props.isVisitCheckedIn || props.visitHasCico;

  const handleClick = (type: "CHANGE" | "UNSCHEDULE") => {
    if (isDisabled) {
      props.onclickDisabled();
      return;
    }
    type === "CHANGE" ? props.onClickOpenChangeDateTime() : props.onClickUnscheduleTask();
  };

  return (
    <InfoCard variant="soft" color="primary" className="PatientTaskScheduleDateTime">
      <AppList density="densed">
        <AppListItem
          leading={<AppIcon icon={CALENDAR_ICON} stroke="var(--primary-color)" />}
          title={globalize().formatLocalDateTime(props.dateTime, { date: "medium" })}
        />
        <AppListItem
          leading={<AppIcon icon={CLOCK_ICON} stroke="var(--primary-color)" />}
          title={`${startTime} - ${endTime} (${durationText})`}
        />
      </AppList>
      <AppButton
        onClick={() => handleClick("CHANGE")}
        color="primary"
        size="small"
        className="__task-schedule-button"
        style={{ opacity: isDisabled ? 0.5 : 1 }}
      >
        {translate(STRINGS.CHANGE)}
      </AppButton>

      <AppButton
        onClick={() => handleClick("UNSCHEDULE")}
        size="small"
        color="white"
        textColor="primary"
        variant="filled"
        className="__task-schedule-button unschedule-button"
        style={{ opacity: isDisabled ? 0.5 : 1 }}
      >
        {translate(STRINGS.UNSCHEDULE)}
      </AppButton>
    </InfoCard>
  );
};

export default PatientTaskScheduleDateTime;
